export default interface Feature {
    id: number;
    name: string;
}

export const featureDefaultProps: Feature = {
    id: 0,
    name: '',
}
